import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TitleDescComponent } from './title-desc/title-desc';
import { NormalModalComponent } from './normal-modal/normal-modal';
import { DeletedAccountComponent } from './deleted-account/deleted-account.component';
import { InsertCodeComponent } from './insert-code/insert-code.component';
import { LoginComponent } from './login/login.component';
import { TwoFactorComponent } from './two-factor/two-factor.component';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { IonicModule } from '@ionic/angular';

import { MaterialModule } from '@app/app-material.module';
import { LoginWrapperComponent } from './login-wrapper/login-wrapper.component';
import { PinComponent } from './pin/pin';
import { BoxWhiteComponent } from './box-white/box-white';
import { LoaderComponent } from './loader/loader';
import { SkeletonComponent } from './skeleton/skeleton';
import { LangComponent } from './lang/lang';
import { BackgroundContentComponent } from './background-content/background-content.component';
import { HeaderComponent } from './header/header';
import { NavbarComponent } from './navbar/navbar';
import { BoxTextComponent } from './box-text/box-text';
import { CalendarComponent } from './calendar/calendar';
import { LoadFileComponent } from './load-file/load-file';
import { ModalImageComponent } from './modal-image/modal-image';
import { DirectivesModule } from '@directive/directives.module';
import { SimpleInfoComponent } from './simple-info/simple-info.component';
import { CompoundCardComponent } from './compound-card/compound-card.component';
import { CardPlanComponent } from './card-plan/card-plan.component';
import { ToggleButtonsComponent } from './toggle-buttons/toggle-buttons.component';
import { TitleTextAreaComponent } from './title-textArea/title-textArea';
import { BoxComponent } from './box/box';
import { ConfirmCredentialsComponent } from './confirm-credentials/confirm-credentials.component';
import { PipeModule } from '@pipes/pipes.modules';
import { ButtonComponent, IconComponent, InputComponent, MenuComponent, RadioComponent, SpinnerComponent } from '@passer-technologies/components';

@NgModule({
  declarations: [
    ConfirmCredentialsComponent,
    TitleDescComponent,
    NormalModalComponent,
    DeletedAccountComponent,
    InsertCodeComponent,
    LoginComponent,
    TwoFactorComponent,
    ErrorMessageComponent,
    LoginWrapperComponent,
    PinComponent,
    BoxWhiteComponent,
    LoaderComponent,
    SkeletonComponent,
    LangComponent,
    BackgroundContentComponent,
    HeaderComponent,
    NavbarComponent,
    BoxTextComponent,
    CalendarComponent,
    LoadFileComponent,
    ModalImageComponent,
    SimpleInfoComponent,
    CompoundCardComponent,
    CardPlanComponent,
    ToggleButtonsComponent,
    TitleTextAreaComponent,
    BoxComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IonicModule.forRoot(),
    DirectivesModule,
    PipeModule,
    RadioComponent,
    InputComponent,
    ButtonComponent,
    IconComponent,
    MenuComponent,
    SpinnerComponent
  ],
  exports: [
    ConfirmCredentialsComponent,
    TitleDescComponent,
    NormalModalComponent,
    DeletedAccountComponent,
    InsertCodeComponent,
    LoginComponent,
    TwoFactorComponent,
    ErrorMessageComponent,
    LoginWrapperComponent,
    PinComponent,
    BoxWhiteComponent,
    LoaderComponent,
    SkeletonComponent,
    LangComponent,
    BackgroundContentComponent,
    HeaderComponent,
    NavbarComponent,
    BoxTextComponent,
    CalendarComponent,
    LoadFileComponent,
    ModalImageComponent,
    SimpleInfoComponent,
    CompoundCardComponent,
    CardPlanComponent,
    ToggleButtonsComponent,
    TitleTextAreaComponent,
    BoxComponent
  ],
})
export class ComponentsModule {}
